<template>
  <v-card class="elevation-0 indigo lighten-5 pb-1">
    <v-card-title class="pl-0">Config Details</v-card-title>
    <v-card-text
      class="ml-0 vop--ace-editor-container"
      :style="{ height: editorHeight }"
    >
      <div ref="jsonEditor" class="vop--ace-editor"></div>
    </v-card-text>
    <v-card-actions class="pl-0"> </v-card-actions>
  </v-card>
</template>

<script>
import ace from "brace";
import "brace/mode/json";
import "brace/theme/eclipse";
import "brace/ext/searchbox";
import * as utils from "@/Shared/utils";
import messages from "@/XVAT/messages.json";

export default {
  name: "JSONEditor",
  props: ["json"],
  computed: {
    editorHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "40vh";
        case "sm":
          return "40vh";
        case "md":
          return "48vh";
        case "lg":
          return "48vh";
        case "xl":
          return "60vh";
        default:
          return "40vh";
      }
    }
  },
  watch: {
    json: {
      handler(newValue, oldValue) {
        this.initValue();
      },
      deep: true
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * Initialize the editor
     * */
    initialzieEditor() {
      let editor = ace.edit(this.$refs.jsonEditor);
      editor.setReadOnly(false);
      this.$refs.jsonEditor.style.backgroundColor = "floralwhite";
      editor.setTheme("ace/theme/eclipse");
      editor.getSession().setMode("ace/mode/json");
      this.initValue();
      var vm = this;
      editor.session.on("change", function(delta, editor) {
        let jsonValue = editor.getValue();
        // let xlstSingleLine = utils.convertXMLToSingleLine(xsltValue);
        // vm.$emit("input", configDetailsValue);
        vm.$emit("update:json", jsonValue);
        // delta.start, delta.end, delta.lines, delta.action
      });
      editor.resize(true);
    },

    /**
     * Initializes  value
     * */
    initValue() {
      let editor = ace.edit(this.$refs.jsonEditor);
      let jsonString = "";
      if (this.json && !this.$lodash.isNull(this.json)) {
        if (typeof this.json === "object") {
          jsonString = JSON.stringify(this.json, null, "\t");
        } else if (typeof this.json === "string") {
          if (utils.IsJson(this.json)) {
            jsonString = JSON.stringify(this.json, null, "\t");
          } else {
            jsonString = this.json;
          }
        } else if (typeof this.json === "number") {
          jsonString = this.json.toString();
        }
      }
      editor.session.setValue(jsonString);
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages;
  },
  updated() {},
  mounted() {
    this.initialzieEditor();
  }
};
</script>
<style lang="scss" scoped>
.vop--ace-editor-container {
  position: relative;
}

.vop--ace-editor {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.vop--ace-editor .ace_search_field,
.ace_searchbtn:last-child {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/ConfigService/JSONEditor.vue